import { useNavigate } from "react-router-dom";

import fruitsImg from "../images/fruits/fruits.png";
import vegetablesImg from "../images/vegetables/vegetables.png";
import spicesImg from "../images/Spices/spices.png";

export default function ProductsPreview() {
  const navigate = useNavigate();

  const handleClick = (category) => {
    navigate(`/products/${category}`);
  };

  return (
    <>
      <div className="products-section">
        <h2 className="products-title">Our Products</h2>

        <div className="card-container">
          {/* Fruits */}
          <div className="card" onClick={() => handleClick("fruits")}>
            <img src={fruitsImg} alt="Fruits" />
            <div className="card-body">
              <h3>Fruits</h3>
              <p>Nature’s Finest, Carefully Selected</p>
              <span>View More →</span>
            </div>
          </div>

          {/* Vegetables */}
          <div className="card" onClick={() => handleClick("vegetables")}>
            <img src={vegetablesImg} alt="Vegetables" />
            <div className="card-body">
              <h3>Vegetables</h3>
              <p>Fresh from Farms, Delivered with Care</p>
              <span>View More →</span>
            </div>
          </div>

          {/* Spices */}
          <div className="card" onClick={() => handleClick("spices")}>
            <img src={spicesImg} alt="Spices" />
            <div className="card-body">
              <h3>Spices</h3>
              <p>Finest Quality, Rich in Aroma & Taste</p>
              <span>View More →</span>
            </div>
          </div>
        </div>
      </div>
      {/* CSS */}
      <style>{`
        .products-section {
          padding: 40px 20px;
          text-align: center;
          background: #f8f9fa;
        }

        .products-title {
          font-size: 32px;
          font-weight: 800;
          text-align: center;
          background: linear-gradient(90deg, #d4af37, #fbbf24);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin-bottom: 20px;
        }

        .card-container {
          display: flex;
          justify-content: center;
          gap: 20px;
          flex-wrap: wrap;
        }

        .card {
          width: 280px;
          border-radius: 12px;
          overflow: hidden;
          background: #fff;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
          cursor: pointer;
          transition: 0.3s ease;
        }

        .card:hover {
          transform: translateY(-8px);
          box-shadow: 0 8px 20px rgba(0,0,0,0.15);
        }

        .card img {
          width: 100%;
          height: 180px;
          object-fit: cover;
        }

        .card-body {
          padding: 15px;
          text-align: left;
        }

        .card-body h3 {
          margin: 0;
          color: #166534;
          font-size: 18px;
          background: linear-gradient(90deg, #0c7f36, #22c55e);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          font-weight: 700;
          }
          
        .card-body p {
          margin: 5px 0 10px;
          color: #666;
          font-size: 14px;
        }

        .card-body span {
          color: #22c55e;
          font-weight: 600;
          font-size: 14px;
        }

        @media (max-width: 768px) {
          .card-container {
            flex-direction: column;
            align-items: center;
          }
        }
      `}</style>
    </>
  );
}
